import { MyMenu } from './menu/my-menu-model'
import { Menu } from './menu/menu-model'
/**
 * 로그인 응답 Action
 */
export const enum LoginResponseAction {
  /**
   * 성공
   */
  SUCCESS,

  /**
   * 메시지에 따른 대화창 표시
   */
  SHOW_DIALOG,

  /**
   * 로그인 성공 후 패스워드 변경 (필수)
   */
  REQUIRE_CHANGE_PASSWORD,

  /**
   * 로그인 성공 후 패스워드 변경 (추천)
   */
  SUCCESS_RECOMMEND_CHANGE_PASSWORD,

  /**
   * 실패 후 승인 요청 필요
   */
  FAIL_REQUIRE_APPROVAL,
}

/**
 * 로그인 결과
 */
export interface LoginResult {
  /**
   * 인증 여부
   */
  isAuthenticated?: boolean

  /**
   * 사용자 조회 여부
   */
  hasUser?: boolean

  /**
   * 사용자 키
   */
  usrKey?: string

  /**
   * 패스워드 초기화 여부
   */
  resetPassword?: boolean

  /**
   * 로그인 실패 수
   */
  loginFailCnt?: number

  /**
   * 비밀번호 미변경 일수
   */
  pwdUnchangedDays?: number

  /**
   * 응답 코드
   */
  resCd?: string

  /**
   * 사용자 메뉴 목록
   */
  myMenus?: MyMenu[]

  /**
   * 메뉴 목록
   */
  menus?: Menu[]

  /**
   * 권한 목록
   */
  authorities?: Authority[]

  /**
   * 후 처리 Action 구분
   */
  actionResponse?: {
    /**
     * 후처리 Action 구분
     */
    action?: LoginResponseAction

    /**
     * 표시 메시지
     */
    message?: string

    /**
     * 승인 요청 유형
     */
    approvalType?: string

    /**
     * 승인 요청 명
     */
    approvalName?: string

    /**
     * 성공 시 이동할 화면
     */
    nextPath?: string
  }
}

/**
 * 권한 정보
 */
export interface Authority {
  /**
   * 메뉴 아이디
   */
  menuId?: string

  /**
   * 프로그램 아이디
   */
  programId?: string

  /**
   * function id
   */
  functionId?: string
}

export interface UserInfo {
  maskEmail?: string
  hp?: string
  hpIdntNo?: string
  hpIntmNo?: string
  hpBckNo?: string

  tel?: string
  tela?: string
  tels?: string
  teli?: string

  maskHp?: string
  userId?: string
  email?: string
  msgCd?: string
}

export interface UserCertReqn {
  msgCntn?: string
  msgCd?: string
  certNo?: string
}

export interface UserCertCondition {
  userid?: string
  dvicid?: string
  certGbn?: string
  certNo?: string
}

export interface UserCertResult {
  msgNm?: string
  msgCd?: string
}

export type DviceCertResult = UserCertResult
